export type BrandedType<Name, Primitive> = Primitive & {
  __type__: Name;
  __primitive__: Primitive;
};

type BrandShape = {
  __type__: any;
  __primitive__: any;
};

export function applyBrand<Type extends BrandShape>(
  value: Type['__primitive__']
): Type {
  return value as Type;
}
